import { useEffect, useState } from "react";
import { Link, Title } from "./Texts";
import { Button, Grid } from "@mui/material";
import { useAppSelector } from "../../store";

export default function LienDemandeAppui() {

	const { user } = useAppSelector((s) => s.auth);

	const [lienDemandeAppui, setLienDemandeAppui] = useState("");

	//Appel Contextuel à faire côté MONSISRA
	useEffect(() => {
		const data = {
			action: "NouvelleDemandeAppui",
			expert: {
				idTechPs: user?.idTechPs,
				libelle: user?.libelle,
				idNatPs: user?.idNatPs,
			}
		}
		const jsonString = JSON.stringify(data);
		const encodedJson = window.btoa(jsonString)
		setLienDemandeAppui(window.config.endpoints.monSisraBaseUrl + "?encodedJson=" + encodedJson);
	}, [user]);

	const copyToClipboard = () => {
		if (navigator.clipboard) { // default: modern asynchronous API
			return navigator.clipboard.writeText(lienDemandeAppui);
		} else {
			// @ts-ignore
			if (window.clipboardData && window.clipboardData.setData) {     // for IE11
				// @ts-ignore
				window.clipboardData.setData('Text', text);
				return Promise.resolve();
			} else {
				// workaround: create dummy input
				const input = document.createElement("input");
				input.type = "text";
				input.value = lienDemandeAppui;
				document.body.append(input);
				input.focus();
				input.select();
				document.execCommand('copy');
				input.remove();
				return Promise.resolve();
			}
		}
	};

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Lien d'accès rapide pour vos demandeurs"} />
			</Grid>

			<Grid item>
				<Grid container spacing={1} alignItems={"center"}>
					<Grid item>
						Vous pouvez partager
					</Grid>
					<Grid item >
						<Link text="CE LIEN" href={lienDemandeAppui} />
					</Grid>
					<Grid item>
						à vos confrères pour leur faciliter la demande d'appui.
					</Grid>
					<Grid item>
						<Button variant="contained" onClick={copyToClipboard}>
							Copier le lien
						</Button>
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid item>
					Ce lien peut être affiché où vous le jugerez utile : le site web de votre établissement, de votre cabinet,
					ou encore dans votre signature de mail ou pied de page de vos modèles de comptes rendus médicaux ...
					Vos demandeurs n'auront qu'à cliquer dessus pour vous solliciter directement.
				</Grid>
			</Grid>
		</Grid >

	);
}
